"use strict";
exports.__esModule = true;
exports.PrimaryTabs = exports.TabList = exports.useTabContext = exports.TabContext = exports.TabPanel = exports.Tab = exports.Tabs = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var lab_1 = require("@material-ui/lab");
exports.useTabContext = lab_1.useTabContext;
var TabList_1 = tslib_1.__importDefault(require("@material-ui/lab/TabList"));
var TabPanel_1 = tslib_1.__importDefault(require("@material-ui/lab/TabPanel"));
var react_1 = tslib_1.__importDefault(require("react"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return core_1.createStyles({
        buttonsFlat: {
            '& > div': {
                '& > div': {
                    minHeight: 40,
                    '& > *': {
                        fontWeight: 400,
                        fontSize: 16,
                        color: (_b = (_a = theme.palette) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.secondary,
                        boxShadow: "inset 0px -1px 0px 0px " + ((_c = theme.palette) === null || _c === void 0 ? void 0 : _c.divider),
                        minHeight: 40,
                        '&.Mui-selected': {
                            color: (_e = (_d = theme.palette) === null || _d === void 0 ? void 0 : _d.text) === null || _e === void 0 ? void 0 : _e.primary,
                            fontWeight: 600
                        },
                        '&:hover': {
                            backgroundColor: (_f = theme.palette) === null || _f === void 0 ? void 0 : _f.action.hover
                        }
                    }
                }
            }
        },
        buttons3d: {
            /**
             * @todo
             * This is just a hack for overflow:hidden
             */
            marginLeft: -8,
            overflow: 'visible',
            '& > div': {
                '& > span': {
                    backgroundColor: 'transparent'
                },
                '& > div': {
                    minHeight: 56,
                    overflow: 'visible',
                    /**
                     * @todo
                     * This is just a hack for overflow:hidden
                     */
                    paddingLeft: 8,
                    '& > *': {
                        fontWeight: 400,
                        fontSize: 20,
                        lineHeight: '24px',
                        color: (_h = (_g = theme.palette) === null || _g === void 0 ? void 0 : _g.text) === null || _h === void 0 ? void 0 : _h.primary,
                        borderRadius: '8px 8px 0px 0px',
                        boxShadow: "inset 0px 0px 8px 0px #ffffff3d",
                        marginTop: '2px',
                        minHeight: 56,
                        marginRight: 4,
                        backgroundColor: ((_j = theme.palette) === null || _j === void 0 ? void 0 : _j.grey[10]) + "CC !important",
                        opacity: 1,
                        overflow: 'visible',
                        '&.Mui-selected': {
                            fontWeight: 600,
                            color: (_l = (_k = theme.palette) === null || _k === void 0 ? void 0 : _k.text) === null || _l === void 0 ? void 0 : _l.primary,
                            overflow: 'visible',
                            backgroundColor: '#ffffff !important',
                            boxShadow: "0px 2px 2px rgba(89, 103, 117, 0.2)"
                        }
                    }
                }
            }
        }
    });
});
function Tabs(props) {
    var _a = props.buttonsVariant, buttonsVariant = _a === void 0 ? 'flat' : _a, children = props.children, rest = tslib_1.__rest(props, ["buttonsVariant", "children"]);
    var classes = useStyles(props);
    return (react_1["default"].createElement(TabList_1["default"], tslib_1.__assign({ className: buttonsVariant === '3d' ? classes.buttons3d : classes.buttonsFlat }, rest), children));
}
exports.Tabs = Tabs;
function Tab(props) {
    return react_1["default"].createElement(core_1.Tab, tslib_1.__assign({}, props));
}
exports.Tab = Tab;
function TabPanel(props) {
    var children = props.children, rest = tslib_1.__rest(props, ["children"]);
    return react_1["default"].createElement(TabPanel_1["default"], tslib_1.__assign({}, rest), children);
}
exports.TabPanel = TabPanel;
function TabContext(props) {
    var children = props.children, rest = tslib_1.__rest(props, ["children"]);
    return react_1["default"].createElement(lab_1.TabContext, tslib_1.__assign({}, rest), children);
}
exports.TabContext = TabContext;
function TabList(props) {
    var children = props.children, rest = tslib_1.__rest(props, ["children"]);
    return react_1["default"].createElement(TabList_1["default"], tslib_1.__assign({}, rest), children);
}
exports.TabList = TabList;
var useTabsStyles = core_1.makeStyles(function (theme) {
    var _a, _b, _c, _d;
    return core_1.createStyles({
        buttonsFlat: {
            '& > div': {
                '& > div': {
                    minHeight: 40,
                    '& > *': {
                        minHeight: 40,
                        fontWeight: 400,
                        fontSize: 16,
                        color: (_a = theme.palette) === null || _a === void 0 ? void 0 : _a.grey[200],
                        boxShadow: "inset 0px -2px 0px " + ((_b = theme.palette) === null || _b === void 0 ? void 0 : _b.grey[70]),
                        minWidth: 0,
                        '&.Mui-selected': {
                            color: (_d = (_c = theme.palette) === null || _c === void 0 ? void 0 : _c.text) === null || _d === void 0 ? void 0 : _d.primary,
                            fontWeight: 600,
                            backgroundColor: 'transparent !important'
                        }
                    }
                }
            }
        }
    });
});
function PrimaryTabs(props) {
    var children = props.children, rest = tslib_1.__rest(props, ["children"]);
    var classes = useTabsStyles(props);
    return (react_1["default"].createElement(TabList_1["default"], tslib_1.__assign({ className: classes.buttonsFlat }, rest), children));
}
exports.PrimaryTabs = PrimaryTabs;
//# sourceMappingURL=Tabs.js.map